import React from "react";
import PT from "prop-types";
import isempty from "lodash/isEmpty";
import { generateUrl } from "@/utils/cloudinary";
import TrashIcon from "_c/icon/Trash";
import { CircleButton } from "_c/button";
import { useSelector } from "react-redux";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { useMut } from "@/hooks/useMut";
import { PortfolioService } from "@/services/Portfolio";

const PhotosList = ({ photos, task, t }) => {
  const authUserId = useSelector(UserSelectors.getUserId);
  const mut = useMut(
    (photo) => {
      PortfolioService.removePhoto(photo, {
        taskId: task._id,
        taskRestPhotos: photos.filter((p) => p._id !== photo._id),
      });
    },
    { t, notifyOnError: true }
  );
  if (isempty(photos)) return null;
  return (
    <ul
      css={`
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
      `}
    >
      {photos.map((photo) => (
        <li
          css={`
            position: relative;
            width: calc(33.333% - 2px);
            padding-bottom: calc(33.333% - 2px);
            margin: 1px;
          `}
          key={photo._id}
        >
          <img
            css={`
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            `}
            alt={photo.desc}
            src={generateUrl(photo.photo)}
          />
          {authUserId === photo.creator && (
            <CircleButton
              disabled={mut.isLoading}
              css={`
                position: absolute;
                top: 7px;
                right: 7px;
              `}
              onClick={() => mut.mutate(photo)}
              medium
              negative
              title={t("common:remove_photo")}
            >
              <TrashIcon width="20" />
            </CircleButton>
          )}
        </li>
      ))}
    </ul>
  );
};

PhotosList.propTypes = {
  photos: PT.array.isRequired,

  updatePhotos: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default PhotosList;
